import React from "react";
import { useNavigate } from "react-router-dom";

const LowerBackPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .lb-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #ecfeff 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .lb-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .lb-hero {
          padding: 26px 22px 34px;
          border-radius: 28px;
          background: linear-gradient(120deg, rgba(20, 184, 166, 0.25), rgba(59, 130, 246, 0.08));
          margin-bottom: 36px;
          display: grid;
          grid-template-columns: minmax(0, 1.5fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .lb-hero {
            grid-template-columns: 1fr;
          }
        }

        .lb-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(20, 184, 166, 0.25);
          color: #0f766e;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .lb-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #14b8a6;
        }

        .lb-title {
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .lb-subtitle {
          font-size: 15px;
          max-width: 560px;
          color: #374151;
        }

        .lb-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 16px 0 18px;
        }

        .lb-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .lb-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 10px;
        }

        .lb-btnPrimary,
        .lb-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .lb-btnPrimary {
          background: #14b8a6;
          color: #ecfeff;
          box-shadow: 0 10px 24px rgba(20, 184, 166, 0.4);
        }

        .lb-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 14px 32px rgba(20, 184, 166, 0.55);
        }

        .lb-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .lb-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .lb-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .lb-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* GENERIC SECTIONS */
        .lb-stripe {
          padding: 32px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.35);
        }

        .lb-sectionTitle {
          font-size: 21px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .lb-sectionSubtitle {
          font-size: 14px;
          color: #4b5563;
          margin-bottom: 18px;
        }

        .lb-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .lb-flexCol {
          flex: 1 1 260px;
        }

        .lb-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        /* LISTS */
        .lb-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 8px;
        }

        .lb-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .lb-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          background: #14b8a6;
          margin-top: 6px;
          flex-shrink: 0;
        }

        /* CARD GRID */
        .lb-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .lb-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .lb-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .lb-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TWO-COLUMN GRID SECTION */
        .lb-twoColGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 20px;
          margin-top: 18px;
        }

        .lb-pillBox {
          padding: 14px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.03);
        }

        .lb-pillTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 6px;
        }

        .lb-pillText {
          font-size: 13px;
          color: #4b5563;
        }

        /* BANNER */
        .lb-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 24px;
        }

        .lb-banner img {
          width: 100%;
          height: 240px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .lb-banner img {
            height: 270px;
          }
        }

        .lb-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.82), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 10px;
        }

        .lb-bannerText {
          color: #ccfbf1;
          font-size: 15px;
          max-width: 420px;
        }

        .lb-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .lb-bannerButtons button {
          font-size: 12px;
          padding: 8px 14px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .lb-bannerButtons .primary {
          background: #14b8a6;
          color: #022c22;
        }

        .lb-bannerButtons .secondary {
          background: rgba(255,255,255,0.18);
          color: #f9fafb;
          border: 1px solid rgba(255,255,255,0.6);
        }

        /* BOTTOM STRIP */
        .lb-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .lb-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .lb-bottomText strong {
          color: #a5f3fc;
        }

        .lb-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .lb-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .lb-bottomActions .primary {
          background: #14b8a6;
          color: #ecfeff;
        }

        .lb-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .lb-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="lb-page">
        <div className="lb-inner">
          {/* HERO */}
          <section className="lb-hero">
            <div>
              <div className="lb-tag">
                <span className="lb-tagDot" />
                Lower Back
              </div>
              <h1 className="lb-title">
                Calm lower back tension so bending, sitting, and walking feel more natural.
              </h1>
              <p className="lb-subtitle">
                The lumbar spine, QL, and erector spinae work all day to support your body. When they get
                irritated or overloaded, they can create aching, sharp twinges, or stiffness that makes it
                hard to relax.
              </p>

              <div className="lb-chips">
                <span className="lb-chip">Lumbar stiffness</span>
                <span className="lb-chip">Tight lower back</span>
                <span className="lb-chip">QL “grabbing” pain</span>
                <span className="lb-chip">Ache with bending or standing</span>
              </div>

              <div className="lb-ctaRow">
                <button
                  className="lb-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book a lower back visit →
                </button>
                <button
                  className="lb-btnSecondary"
                  onClick={() => navigate("/staff")}
                >
                  Meet our therapists
                </button>
              </div>
            </div>

            <div className="lb-heroImgWrap">
              <img
                src="/content/lower-back/lower_back_hero.png"
                alt="Therapist assessing lower back in clinic"
                className="lb-heroImg"
              />
            </div>
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="lb-stripe">
            <div className="lb-sectionTitle">What can go wrong in the lower back?</div>
            <p className="lb-sectionSubtitle">
              The lumbar spine and its supporting muscles help you bend, stand, twist, and transfer weight.
              With repeated strain, long sitting, or sudden overload, they can start to signal for help.
            </p>

            <div className="lb-flexRow">
              <div className="lb-flexCol">
                <ul className="lb-list">
                  <li>
                    <span className="lb-bullet" />
                    <span>
                      Lumbar stiffness or ache that builds through the day, especially with sitting or standing.
                    </span>
                  </li>
                  <li>
                    <span className="lb-bullet" />
                    <span>
                      QL tightness along one side of the low back or flank that can “grab” with certain movements.
                    </span>
                  </li>
                  <li>
                    <span className="lb-bullet" />
                    <span>
                      Erector spinae fatigue along the spine after lifting, yard work, or long days on your feet.
                    </span>
                  </li>
                  <li>
                    <span className="lb-bullet" />
                    <span>
                      Feeling guarded when you bend forward or return to standing.
                    </span>
                  </li>
                  <li>
                    <span className="lb-bullet" />
                    <span>
                      Discomfort rolling in bed or getting out of a chair.
                    </span>
                  </li>
                </ul>

                <div className="lb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="lb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    See if this sounds like you →
                  </button>
                  <button
                    className="lb-btnSecondary"
                    onClick={() => navigate("/contact")}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="lb-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/lower-back/lower_back_lumbar_spine.png"
                  alt="Therapist guiding lumbar spine motion"
                  className="lb-img"
                />
              </div>
            </div>

            <div className="lb-cardGrid">
              <div className="lb-card">
                <div className="lb-cardTitle">Lumbar Spine</div>
                <div className="lb-cardText">
                  The lower part of the spine that handles bending, extending, and carrying load from the upper body.
                </div>
              </div>
              <div className="lb-card">
                <div className="lb-cardTitle">Quadratus Lumborum (QL)</div>
                <div className="lb-cardText">
                  A deep side/back muscle that helps with side-bending and stabilizing the pelvis and spine.
                </div>
              </div>
              <div className="lb-card">
                <div className="lb-cardTitle">Erector Spinae</div>
                <div className="lb-cardText">
                  A long group of muscles running along the spine that extend and support your back.
                </div>
              </div>
            </div>
          </section>

          {/* QL & SIDE FLANK */}
          <section className="lb-stripe">
            <div className="lb-flexRow">
              <div className="lb-flexCol">
                <img
                  src="/content/lower-back/lower_back_ql.png"
                  alt="Manual therapy along QL and low back flank"
                  className="lb-img"
                />
              </div>

              <div className="lb-flexCol">
                <div className="lb-sectionTitle">That “grabby” side-of-low-back feeling</div>
                <p className="lb-sectionSubtitle">
                  The QL can feel like it clamps down when it&apos;s working overtime to keep you upright
                  or compensate for stiffness elsewhere.
                </p>

                <ul className="lb-list">
                  <li>
                    <span className="lb-bullet" />
                    <span>
                      One-sided tightness or tenderness along the low back or flank.
                    </span>
                  </li>
                  <li>
                    <span className="lb-bullet" />
                    <span>
                      Discomfort with side-bending, carrying on one side, or standing on one leg.
                    </span>
                  </li>
                  <li>
                    <span className="lb-bullet" />
                    <span>
                      A feeling of “locking up” during certain movements that slowly eases with gentle motion.
                    </span>
                  </li>
                </ul>

                <div className="lb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="lb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Start lower back PT →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="lb-stripe">
            <div className="lb-sectionTitle">How physical therapy supports your lower back</div>
            <p className="lb-sectionSubtitle">
              We look at how your spine, hips, core, and daily movements are sharing the load, then build a plan
              that fits your life.
            </p>

            <div className="lb-twoColGrid">
              <div className="lb-pillBox">
                <div className="lb-pillTitle">Gentle mobility & decompression</div>
                <div className="lb-pillText">
                  Guided movements and positions that help the lower back move without feeling forced or unsafe.
                </div>
              </div>
              <div className="lb-pillBox">
                <div className="lb-pillTitle">Soft-tissue work</div>
                <div className="lb-pillText">
                  Hands-on treatment for QL, erector spinae, and surrounding muscles to reduce guarding and tension.
                </div>
              </div>
              <div className="lb-pillBox">
                <div className="lb-pillTitle">Core & hip support</div>
                <div className="lb-pillText">
                  Strengthening the deep core and hips so the lumbar spine doesn&apos;t have to carry everything.
                </div>
              </div>
              <div className="lb-pillBox">
                <div className="lb-pillTitle">Position & pacing strategies</div>
                <div className="lb-pillText">
                  Practical ideas for sitting, standing, and lifting that reduce strain while you stay active.
                </div>
              </div>
            </div>

            <div className="lb-ctaRow" style={{ marginTop: "18px" }}>
              <button
                className="lb-btnPrimary"
                onClick={() => navigate("/appointments")}
              >
                Book a lower back session →
              </button>
              <button
                className="lb-btnSecondary"
                onClick={() => navigate("/insurance")}
              >
                Check my insurance
              </button>
            </div>
          </section>

          {/* EXERCISES / VISIT FLOW */}
          <section className="lb-stripe">
            <div className="lb-flexRow">
              <div className="lb-flexCol">
                <img
                  src="/content/lower-back/lower_back_exercises.png"
                  alt="Patient doing gentle lower back exercises with therapist"
                  className="lb-img"
                />
              </div>

              <div className="lb-flexCol">
                <div className="lb-sectionTitle">What a lower back visit may look like</div>

                <div className="lb-twoColGrid">
                  <div className="lb-pillBox">
                    <div className="lb-pillTitle">1. Your story</div>
                    <div className="lb-pillText">
                      We talk through when your lower back bothers you, what helps, and what you&apos;re worried about.
                    </div>
                  </div>
                  <div className="lb-pillBox">
                    <div className="lb-pillTitle">2. Motion check</div>
                    <div className="lb-pillText">
                      We gently test bending, extending, and side-bending, plus how your hips and core are helping.
                    </div>
                  </div>
                  <div className="lb-pillBox">
                    <div className="lb-pillTitle">3. Hands-on care</div>
                    <div className="lb-pillText">
                      You try specific manual techniques and positions to see what eases your back.
                    </div>
                  </div>
                  <div className="lb-pillBox">
                    <div className="lb-pillTitle">4. Short home plan</div>
                    <div className="lb-pillText">
                      You leave with a small, realistic routine for home or work—without a long list to memorize.
                    </div>
                  </div>
                </div>

                <div className="lb-ctaRow" style={{ marginTop: "16px" }}>
                  <button
                    className="lb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book a lower back evaluation →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="lb-stripe">
            <div className="lb-banner">
              <img
                src="/content/lower-back/lower_back_banner.png"
                alt="Bright PT clinic for lower back care"
              />
              <div className="lb-bannerOverlay">
                <div className="lb-bannerText">
                  Lower back sessions happen in a calm, one-on-one environment where we match your plan
                  to your comfort level, work, and activity goals.
                </div>
                <div className="lb-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule a lower back visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* SAFETY NOTE */}
          <section className="lb-stripe">
            <div className="lb-bottomStrip">
              <div className="lb-bottomText">
                If you notice sudden severe back pain with loss of bladder or bowel control, numbness in the
                inner thighs or groin, rapidly worsening weakness, or back pain with fever or unexplained weight
                loss, <strong>seek urgent or emergency medical care first.</strong> Physical therapy can then help
                support recovery once serious causes are ruled out.
              </div>
              <div className="lb-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Schedule lower back PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default LowerBackPT;
